module.exports = __webpack_public_path__ + "static/media/9.d3ae7698.jpg";